/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import sidekick from '@last-rev/contentful-sidekick-util';
import styles from './StandardCard.module.scss';
import Asset from '../../Asset';
import AssetPropTypes from '../../Asset/AssetPropTypes';
import ImageExpand from '../../ImageExpand';
import ElementLink, { ElementLinkPropTypes } from '../../ElementLink/ElementLink';
import RichTextParserPropTypes from '../../RichTextParser/RichTextParserPropTypes';
import RichTextParser from '../../RichTextParser/RichTextParser';

export const StandardCardPropTypes = {
  _id: PropTypes.string,
  headerText: PropTypes.string,
  summaryRichText: PropTypes.shape(RichTextParserPropTypes),
  image: PropTypes.shape(AssetPropTypes),
  imageExpand: PropTypes.bool,
  cta: PropTypes.shape(ElementLinkPropTypes),
  className: PropTypes.string
};

const CardContent = ({ _id=null, headerText=null, image=null, imageExpand=false, cta=null, summaryRichText=null, className=null }) => (
    <div className={cx(styles.card, [className])}>
      {headerText || summaryRichText ? (
        <div data-testid="StandardCard-TextWrap" className={styles.cardBody}>
          {headerText ? (
            <div className={styles.cardTitleWrap} {...sidekick(_id, 'headerText', null, 'Header Text')}>
              <h3 data-testid="StandardCard-headerText" className={styles.cardTitle}>
                {headerText}
              </h3>
            </div>
          ) : null}

          {summaryRichText ? (
            <div className={styles.cardTextWrap} {...sidekick(_id, 'summaryRichText', null, 'Summary Rich Text')}>
              <div data-testid="StandardCard-summaryRichText" className={styles.cardText}>
                <RichTextParser document={summaryRichText} />
              </div>
            </div>
          ) : null}
        </div>
      ) : null}

      {cta && cta.linkText ? (
        <div data-testid="StandardCard-footer" className={styles.cardFooter}>
          {cta.linkText}
        </div>
      ) : null}
    </div>
  );

CardContent.propTypes = StandardCardPropTypes;


function StandardCard({ _id=null, headerText=null, image=null, imageExpand=false, cta=null, summaryRichText=null, className=null }) {
  return (
    <div data-testid="StandardCard" className={styles.cardWrap}>
      {cta && cta.href ? (
        <ElementLink
          href={cta.href}
          as={cta.as}
          linkText={cta.linkText}
          isModal={false}
          download={false}
          className={styles.cardLinkWrap}>
          <CardContent
            _id={_id}
            headerText={headerText}
            summaryRichText={summaryRichText}
            image={image}
            imageExpand={imageExpand}
            cta={cta}
            className={className}
          />
        </ElementLink>
      ) : (
        <CardContent
          _id={_id}
          headerText={headerText}
          summaryRichText={summaryRichText}
          image={image}
          imageExpand={imageExpand}
          cta={cta}
          className={className}
        />
      )}
    </div>
  );
}

StandardCard.propTypes = StandardCardPropTypes;

export default StandardCard;